export enum TeamTabStateEnum {
  Users = 'users',
  Groups = 'groups',
}
